export function validateYoutubeUrl(url) {
    if (!url) return false;
    
    const pattern = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(\S*)?$/;
    return pattern.test(url);
}

export function extractVideoId(url) {
    if (!url) return null;
    
    let videoId = null;
    const patterns = [
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
        /^[a-zA-Z0-9_-]{11}$/
    ];

    for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match) {
            videoId = match[1];
            break;
        }
    }

    return videoId;
}

// Create safe YouTube embed URLs using privacy-enhanced mode
export function createYouTubeEmbedUrl(url) {
    const videoId = extractVideoId(url);
    if (!videoId) return null;
    
    // Use YouTube's privacy-enhanced mode
    return `https://www.youtube-nocookie.com/embed/${videoId}`;
}

// Create a YouTube thumbnail URL
export function getYouTubeThumbnailUrl(url) {
    const videoId = extractVideoId(url);
    if (!videoId) return null;
    
    // Return the high quality thumbnail
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

// Open YouTube video safely without COOP restrictions
export function openYouTubeVideo(url) {
    const videoId = extractVideoId(url);
    if (!videoId) return;
    
    // Use YouTube's nocookie domain to avoid tracking and COOP issues
    const safeUrl = `https://www.youtube-nocookie.com/watch?v=${videoId}`;
    
    // Use noopener and noreferrer to prevent the new page from accessing window.opener
    window.open(safeUrl, '_blank', 'noopener,noreferrer');
}

// Function to create a direct link to a YouTube video with timestamp
export function createYouTubeTimestampLink(url, timeInSeconds) {
    const videoId = extractVideoId(url);
    if (!videoId) return null;
    
    return `https://www.youtube-nocookie.com/watch?v=${videoId}&t=${Math.floor(timeInSeconds)}s`;
}
